import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import { parse, isValid } from "date-fns";

// Slider de "Eventos Pasados" de la pagina principal.
//
// Antes era una <section> con slick (jQuery) que se inicializaba con un
// setTimeout de 1 s. Problemas que tenia:
//  - Si slick no llegaba a inicializar, se veian TODOS los eventos pasados
//    (50+) uno debajo del otro: una lista larguisima, sobre todo en celular.
//  - Cada imagen era un <img> SIN src con la foto como background-image:
//    el loading="lazy" no aplica a fondos, asi que se descargaban todas las
//    fotos (~37 MB) apenas se abria la pagina, se vieran o no.
//  - La fecha se parseaba con new Date("YYYY-MM-DD HH:mm:ss"), que en Safari
//    (iPhone) da Invalid Date -> en iPhone no se mostraba ningun evento.
//
// Ahora: solo los ultimos MAX_EVENTOS, con <img src> real + loading="lazy"
// (el navegador baja solo las que estan por verse) en un Swiper.
const MAX_EVENTOS = 12;

function fechaFinDelDia(fecha) {
    const d = parse(String(fecha || "") + " 23:59:59", "yyyy-MM-dd HH:mm:ss", new Date());
    return isValid(d) ? d : null;
}

export default function EventosPasados({ eventos }) {
    const pasados = useMemo(() => {
        const ahora = new Date();
        return (Array.isArray(eventos) ? eventos : [])
            .map((e) => ({ e, fin: fechaFinDelDia(e.fechaConcierto) }))
            .filter(({ e, fin }) => e && e.imagenConcierto && fin && fin < ahora)
            .sort((a, b) => b.fin - a.fin)
            .slice(0, MAX_EVENTOS)
            .map(({ e }) => e);
    }, [eventos]);

    if (pasados.length === 0) return null;

    return (
        <Swiper
            className="w-100"
            modules={[Autoplay]}
            spaceBetween={8}
            slidesPerView={1.15}
            breakpoints={{
                520: { slidesPerView: 2 },
                750: { slidesPerView: 3 },
            }}
            loop={pasados.length > 3}
            autoplay={{ delay: 1800, disableOnInteraction: false }}
        >
            {pasados.map((e) => (
                <SwiperSlide key={e.codigoEvento || e.id || e.imagenConcierto}>
                    <img
                        src={e.imagenConcierto}
                        alt={e.nombreConcierto || "Evento pasado"}
                        loading="lazy"
                        decoding="async"
                        className="rounded-7"
                        style={{
                            height: "150px",
                            width: "100%",
                            objectFit: "cover",
                            display: "block",
                            backgroundColor: "#e9ecef",
                        }}
                    />
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
